//@ts-strict-ignore
import workspaceQuery from 'graphql/queries/sales/DataSheetWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/sales/DataSheetListQuery.graphql';
import instanceQuery from 'graphql/queries/sales/DataSheetQuery.graphql';
import fragment from 'graphql/fragments/sales/DataSheetFragment.graphql';

import generateRangeMutation from 'graphql/mutations/sales/DataSheetGenerateRangeMutation.graphql';
import reprintMutation from 'graphql/mutations/sales/DataSheetReprintMutation.graphql';

import * as printFunctions from '../../../actions/sales/DataSheetAction';
import { customerDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const DataSheet: EntityType = {
  type: 'DataSheet',
  title: 'DataSheet',
  formUrl: '/Sales/DataSheets/Form/',
  formTitle: 'Print Data Sheets',
  workspaceUrl: '/Sales/DataSheets/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentSuffix',
  },
  fragment,
  printFunctions: printFunctions,
  screenReference: 'SALES_DOCUMENTS_DATA_SHEETS',
  configuration: {
    title: 'Data Sheet',
    field: 'dataSheetDocumentDefault',
    reportType: ReportType.DataSheet,
    customerField: 'customerDataSheetDocumentDefault',
    receiveFlag: 'receiveDataSheets',
  },
  operations: 0,
  mergeFields: customerDocument,
};

export default DataSheet;
